import { T as d, F as f, E as h, _ as y, M as g, a as x, b as E, R as T, P as w, W as R, j as u, K as b } from "./index-2269cfe0.js";
import m, { createElement as S, useCallback as j } from "react";
import { c as $ } from "./WCLComponent.styles-68ac5b1f.js";
import { E as W } from "./ErrorBoundary-60d80e23.js";
import "styled-components";
const C = (e) => {
  if (e)
    return "text-decoration: underline;";
}, F = (e) => {
  switch (e) {
    case "medium":
      return "font-weight: 500;";
    case "regular":
      return "font-weight: 400;";
  }
}, K = d(/* @__PURE__ */ m.forwardRef(function({ element: t, children: s, className: r, testId: a, id: n, domProps: o }, c) {
  return /* @__PURE__ */ S(t, {
    className: r,
    id: n,
    "data-testid": a,
    ref: c,
    ...o
  }, s);
}))`
  ${({ variant: e }) => M(e)}
  ${({ underlined: e }) => C(e)}
  ${({ weight: e }) => F(e)}
  ${$}
`, M = (e) => {
  switch (e) {
    case "h1":
      return R();
    case "h2":
      return w();
    case "h3":
      return T();
    case "h4":
      return E();
    case "h5":
      return x();
    case "body":
      return g();
    case "paragraph":
      return y();
    case "small":
      return h();
    case "medium":
      return f();
  }
}, U = /* @__PURE__ */ m.forwardRef(function({ testId: t = "typography", color: s = b, variant: r = "body", children: a, underlined: n = !1, weight: o = "medium", element: c, ...i }, p) {
  const l = j(() => r === "body" || r === "paragraph" || r === "small" || r === "medium" ? "span" : r, [
    r
  ]);
  return /* @__PURE__ */ u.jsx(W, {
    children: /* @__PURE__ */ u.jsx(K, {
      color: s,
      testId: t,
      element: c || l(),
      variant: r,
      weight: o,
      underlined: n,
      ref: p,
      ...i,
      children: a
    })
  });
});
export {
  U as Typography
};
